<div class="header">
  UK Importer
</div>
<div class="content">
  Philips Electronics UK Limited<br>
  Ascent 1<br>
  Farnborough Aerospace Centre<br>
  Farnborough<br>
  GU14 6XW<br>
</div>
